/**
 * GlobalOverlays — mounts the app-wide floating UI that survives
 * navigation: the persistent deploy drawer and the ⌘K command palette.
 *
 * Both pull their state from Zustand stores, so remounting them on
 * every route change is cheap: the visible state is derived from the
 * store, not from React component identity. The drawer keeps running
 * its poller as long as `deployStore.activeJobId` is set; the palette
 * re-attaches its global `⌘K` handler on mount.
 *
 * Every feature route defined by Subagent D renders <GlobalOverlays />
 * once so the drawer + palette are always available. Dashboard (owned
 * by Subagent C) may choose to add it separately if desired.
 */
import { CommandPalette } from '@/components/CommandPalette';
import { DeployDrawer } from '@/components/DeployDrawer';
import { useDeployPoller } from '@/hooks/useDeploy';

export function GlobalOverlays() {
  // Drive deploy job polling from whichever page happens to be mounted.
  useDeployPoller();
  return (
    <>
      <DeployDrawer />
      <CommandPalette />
    </>
  );
}
